import { Component } from '@angular/core';
import { SimplifiedHeaderComponent } from '../legal-pages/simplified-header/simplified-header.component';

@Component({
  selector: 'app-not-found-page',
  standalone: true,
  imports: [SimplifiedHeaderComponent],
  templateUrl: './not-found-page.component.html',
  styleUrl: './not-found-page.component.scss',
})
export class NotFoundPageComponent {}
